<div [ngClass]="commonService.isHidden ?'':'container-fluid'">
    <div class="card-block" style="margin-left: 20px; margin-right: -12px;">
        <div class="document-view-container dark-theme-container">

            <!-- Loading indicator -->
            <div *ngIf="!noAccess && isLoading" class="loading-container">
                <p>Loading document...</p>
            </div>

            <!-- Error message -->
            <div *ngIf="!noAccess && errorMessage && !isLoading && !showPicViewer" class="error-container">
                <div class="alert alert-danger">
                    <p>{{ errorMessage }}</p>
                </div>
            </div>

            <!-- Document viewer -->
            <div *ngIf="!noAccess && !isLoading && showPicViewer && picData" class="document-viewer">
                <!-- Header -->
                <div class="viewer-header">
                    <div class="header-title">
                        <h2>Document View</h2>
                    </div>
                    <div class="header-actions">
                        <button class="download-btn" (click)="downloadDocument()" type="button" aria-label="Download"
                            title="Download Document">
                            <i class="fas fa-download"></i>
                        </button>
                    </div>
                </div>

                <!-- Document content viewer -->
                <div class="document-content">
                    <!-- PDF Viewer -->
                    <iframe *ngIf="fileCategory === 'pdf'" [src]="picData.picFile" class="document-iframe"></iframe>

                    <!-- Video Viewer -->
                    <video *ngIf="fileCategory === 'video'" [src]="picData.picFile" class="document-video" controls
                        style="width: 100%; max-height: 70vh;"></video>

                    <!-- Audio Viewer -->
                    <audio *ngIf="fileCategory === 'audio'" [src]="picData.picFile" class="document-audio" controls
                        style="width: 100%;"></audio>

                    <!-- Image Viewer -->
                    <img *ngIf="fileCategory === 'image'" [src]="picData.picFile" class="document-image"
                        alt="Document" />

                    <!-- Unsupported Format -->
                    <div *ngIf="fileCategory === 'doc' || fileCategory === 'cad' || fileCategory === 'other'"
                        class="unsupported-format">
                        <p>Preview not available for this file type</p>
                        <p style="font-size: 12px; margin-top: 10px; color: #999;">
                            Type: {{ fileCategory }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>